import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));
})();

(function($) {
	$(document).ready(function() {
		$('.fancy-form').fancybox();
		$('.fancy-img').fancybox();
	});

	$('input[name=moscow]').click(function(){
		var v = ($(this).val());
		console.log(v);
		if(v === 'do-7000'){
			$('#do-7000').show();
			$('#ot-7000').hide();
		}
		else{
			$('#do-7000').hide();
			$('#ot-7000').show();
		}
	});

	$('input#moscow-18').change(function(){
		if (jQuery('input#moscow-18').prop('checked')) {
			jQuery('#moscow-specialprise').show();
			jQuery('#moscow-prise').hide();
		} else {
			jQuery('#moscow-specialprise').hide();
			jQuery('#moscow-prise').show();
		}
	});
	$('input#moscow-size').change(function(){
		if (jQuery('input#moscow-size').prop('checked')) {
			jQuery('#moscow-maxi').show();
			jQuery('#moscow-mini').hide();
		} else {
			jQuery('#moscow-maxi').hide();
			jQuery('#moscow-mini').show();
		}
	});

	$('input[name=moscow-obl]').click(function(){
		var v = ($(this).val());
		console.log(v);
		if(v === 'do-5km'){
			$('#do-5km').show();
			$('#5km-20km').hide();
			$('#ot-20km').hide();
		}
		if(v === '5km-20km'){
			$('#do-5km').hide();
			$('#5km-20km').show();
			$('#ot-20km').hide();
		}
		if(v === 'ot-20km'){
			$('#do-5km').hide();
			$('#5km-20km').hide();
			$('#ot-20km').show();
		}
	});

	$("input#special-moscow-obl").change(function(){
		if (jQuery(this).prop('checked')) {
			jQuery('#moscow-obl-specialprise').show();
			jQuery('#moscow-obl-prise').hide();
		} else {
			jQuery('#moscow-obl-specialprise').hide();
			jQuery('#moscow-obl-prise').show();
		}
	});
})(jQuery);